<template>

    <div class="flex flex-col break-words bg-white border border-2 border-theme-level4 rounded shadow-md mt-4">
        <div class="flex flex-row items-center justify-between bg-theme-level4">
            <div class="flex flex-row">
                <div class="handle text-gray-700 py-2 pl-2 mb-0 cursor-move">
                    <svg class="fill-current text-gray-400" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z"/></svg>
                </div>
                <div class="text-theme-discrete py-3 px-4 mb-0 w-full">
                    <span class="text-theme-muted">ID: {{ title }}</span> Español: <span class="font-semibold text-theme-main">{{ bodyText }}</span> - English: <span class="font-semibold text-theme-main">{{ bodyTextEn }}</span>
                </div>
            </div>
            <div class="flex flex-row items-center">
                <p class="text-base text-theme-main mr-4">{{ message }}</p>
                <input type="checkbox" v-model="active" @input="triggerActiveToggle(title)"
                       class="form-checkbox h-5 w-5 text-theme-controls3 mr-4">
            </div>

        </div>

    </div>

</template>

<script>

    export default {

        props: [

            'title',
            'bodyText',
            'bodyTextEn',
            'is_active',
            'message'

        ],

        data() {

            return {

                active: this.is_active

            }

        },

        methods: {

            triggerActiveToggle(id) {

                Event.fire('toggleActiveSection', { 'id': id })

            }

        },

    }

</script>
